export const mpluskassa = {
  seo: {
    title: 'M+ Kassa integration | Bistroo',
    description: 'Connect M+ Kassa to your Bistroo webshop. Online orders are automatically processed as POS receipts — reliable and easy to set up.',
  },
  hero: {
    category: 'POS system',
    description: 'Online orders via Bistroo land directly as POS receipts in M+ Kassa. Reliable, simple and fully automated.',
  },
  about: {
    title: 'What does M+ Kassa do?',
    p1: 'M+ Kassa is a proven POS software package from M+ Software, developed specifically for the Dutch restaurant industry. The system provides complete POS functionality with table management, staff login, VAT splitting and daily reports — all in one clear interface.',
    p2: 'Via the Bistroo connection, online orders are automatically sent to M+ Kassa. Your staff does not need to watch screens or enter orders manually. The connection works seamlessly, even during a busy lunchtime or evening peak.',
    benefits_title: 'What does the connection deliver?',
    benefits: [
      'Automatic POS receipt for every online order',
      'No manual entry, prints directly',
      'Product categories and VAT rates synchronized',
      'Pickup times displayed on the POS receipt',
      'Daily revenue combined in M+ Kassa report',
    ],
  },
  wordcloud_title: 'M+ Kassa at a glance',
  wordcloud: ['POS software', 'Touchscreen', 'Hospitality POS', 'Daily revenue', 'VAT split', 'Receipt', 'Kitchen printer', 'Table management', 'Staff management', 'Order processing', 'Receipt code', 'Automatic', 'Sync', 'Branch management', 'M+ Software'],
  usp: {
    heading: 'Why connect Bistroo to M+ Kassa?',
    items: [
      { icon: 'bi-lightning-fill', title: 'Automatic POS receipt', text: 'As soon as a customer orders via Bistroo, M+ Kassa prints the receipt immediately. No screens to monitor, no retyping.' },
      { icon: 'bi-printer', title: 'Kitchen and bar split', text: 'Configure per product category which printer a receipt goes to. Hot dishes to the kitchen, drinks to the bar.' },
      { icon: 'bi-percent', title: 'Correct VAT splitting', text: 'M+ Kassa processes the VAT split automatically based on your product settings in Bistroo. No manual corrections.' },
      { icon: 'bi-clipboard-data-fill', title: 'Combined daily report', text: 'Online revenue via Bistroo and offline POS revenue appear combined in your M+ Kassa daily report.' },
      { icon: 'bi-list-check', title: 'Product list always in sync', text: 'Import your M+ Kassa products as a starting point for your Bistroo menu. Adjustments are managed centrally and immediately visible in your webshop.' },
      { icon: 'bi-clock-history', title: 'Smooth peak hour operations', text: "Bistroo's time-slot system and M+ Kassa work together: the kitchen gets exactly the amount of orders it can handle, even during lunch and evening peaks." },
    ],
  },
  setup: {
    heading: 'How to connect M+ Kassa to Bistroo',
    steps: [
      'Log in to your M+ Kassa management environment and go to Settings → Integrations.',
      'Generate an API token and note your location ID.',
      'Open Bistroo Merchant Portal → Integrations → M+ Kassa.',
      'Enter the API token and location ID and confirm the connection.',
      'Map your product groups and process a test order to verify everything.',
    ],
  },
  faq: {
    items: [
      { q: 'Does the connection work with all M+ Kassa versions?', a: 'The integration is available for M+ Kassa version 6 and higher. Contact M+ Software support if you are unsure about your version.' },
      { q: 'Can multiple tills be connected?', a: 'Yes. If you have multiple terminals, you can configure per terminal or per department which printer receives orders. This way hot dishes go to the kitchen and drinks to the bar.' },
      { q: 'Are pickup time slots passed on?', a: 'Yes. The pickup time the customer selects in the Bistroo webshop is displayed as a prominent instruction on the POS receipt, so the kitchen knows exactly when something needs to be ready.' },
      { q: 'What if my POS is offline?', a: 'Bistroo stores incoming orders and automatically forwards them as soon as the connection with M+ Kassa is restored. You never lose a single order.' },
      { q: 'How do I keep my menu synchronized across both systems?', a: 'The Bistroo Merchant Portal is the leading system for your online menu. You can import products from M+ Kassa as a starting point, but online adjustments (descriptions, photos, time windows) are managed in Bistroo.' },
    ],
  },
}
